import React from 'react';

export default function EmailIcon (props) {
    return (
        <svg className={props.className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.99 20.82">
            <path d="M0,10.42C0,4,3.85,0,10.39,0,16.63,0,20,4.28,20,9.19c0,3.45-.66,6.88-4.14,6.94-1.4.05-2.82-.53-3-1.84h-.1A3.35,3.35,0,0,1,9.28,16c-2.75-.1-4.46-2.35-4.46-5.7s2-5.17,4.38-5.45c1.71-.2,3.13.44,3.37,1.16h.11V5.13h2V12.7c0,.86.46,1.55,1.3,1.55,1.49,0,2-1.6,1.94-5.14,0-4.15-2.84-7.22-7.62-7.22-5.22,0-8.14,3.36-8.14,8.55,0,5.42,3,8.45,8.44,8.45a14.42,14.42,0,0,0,4.4-.84l.57,1.79a14.13,14.13,0,0,1-5.07,1C3.75,20.82,0,17.05,0,10.42Zm12.69-.2c0-2.48-.9-3.36-2.9-3.36-1.85,0-2.9,1.49-2.91,3.37S7.62,14,9.76,14,12.7,12.77,12.69,10.22Z"/>
        </svg>
    );
}